const start = 0;
const factor = window.innerWidth * 0.66;
const transformCSS = (value) => `translateX(${value}px)`;
var translateX = start;

const slide = (container, direction) => {
  const next = direction * factor + translateX;
  const end = container
    ? -(container.scrollWidth - window.innerWidth)
    : translateX;

  // Clamp translation to the edge of the first/last image.
  translateX = next > -start ? -start : next < end ? end : next;

  // Apply the new style to the container.
  container.style.transform = transformCSS(translateX);
}


